import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { manageFolderFilterSliceInitialState } from "./initialState";

const manageFolderFilterSlice = createSlice({
  name: "manageFolderFilters",
  initialState: () => {
    const initialState = { ...manageFolderFilterSliceInitialState };
    return initialState;
  },
  reducers: {
    setFolderName(state, action: PayloadAction<string>) {
      state.folderName = action.payload;
      return state;
    },
    setActiveTab(state, action: PayloadAction<string>) {
      state.activeTab = action.payload;
      return state;
    },
    setPageNumber(state, action: PayloadAction<number>) {
      state.pageNumber = action.payload;
      return state;
    },
    setActiveTabFolderCount(state, action: PayloadAction<number>) {
      state.activeTabFolderCount = action.payload;
      return state;
    },
  },
});

export const { setActiveTab, setFolderName, setPageNumber, setActiveTabFolderCount } =
  manageFolderFilterSlice.actions;

export default manageFolderFilterSlice;
